import { FunctionComponent } from "react";

import { Box } from "@mui/system";

import { LinkButton } from "./button";

interface LanguageSwitchProps {
  variant: "code1" | "navigation1";
}

export const LanguageSwitch: FunctionComponent<LanguageSwitchProps> = ({
  variant,
}) => {
  return (
    <Box sx={{ display: "flex", gap: "36px" }}>
      <LinkButton text={"ENG"} variant={variant} url={"#"} locale={"en"} />

      <LinkButton text={"PL"} variant={variant} url={"#"} locale={"pl"} />
    </Box>
  );
};
